module.exports = __webpack_public_path__ + "img/active-move-icon.fe6da555.svg";